import * as CONSTANTS from './actions-constants';

export const initialState = {
  // name of package bought by user
  packageName: '',
  packageSku: ''
};

export const checkoutReducerKey = 'dataServiceCheckout';

export const checkoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SET_PACKAGE_NAME: {
      return {
        ...state,
        packageName: action.payload
      };
    }
    case CONSTANTS.SET_PACKAGE_SKU: {
      return {
        ...state,
        packageSku: action.payload
      };
    }

    default:
      return state;
  }
};
